import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, inject, Injector, ElementRef, Input, Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { DotRendererService } from '@ng-dot/core';
const _c0 = ["*"];
const _c1 = "body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n";
const _c2 = "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n";
const _c3 = "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n";
const STYLE_URLS = ['../../../../node_modules/@css-dot/core/prebuilt/reset.css', '../../../../node_modules/@css-dot/core/prebuilt/frames/by-container.css', 'dot-frame.scss'];
class DotFrameAreaDirective {
  static ɵfac = function DotFrameAreaDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotFrameAreaDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotFrameAreaDirective,
    selectors: [["", "dotFrameArea", ""]],
    hostAttrs: [1, "_dot-target"],
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotFrameAreaDirective, [{
    type: Directive,
    args: [{
      selector: '[dotFrameArea]',
      host: {
        class: '_dot-target'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotFrameComponentBase {
  /**
   * Max Width
   * @default 2400
   * @param width
   */
  set max(width) {
    this._renderer.setStyle(this._host, '--frame-max-width', `${width}px`);
  }
  /**
   * Min Width
   * @default 320
   * @param width
   */
  set min(width) {
    this._renderer.setStyle(this._host, '--frame-min-width', `${width}px`);
  }
  resize;
  _renderer;
  _host;
  constructor() {
    const injector = inject(Injector);
    this._renderer = injector.get(DotRendererService);
    this._host = injector.get(ElementRef).nativeElement;
  }
  static ɵfac = function DotFrameComponentBase_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotFrameComponentBase)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotFrameComponentBase,
    hostVars: 2,
    hostBindings: function DotFrameComponentBase_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("_resize", ctx.resize);
      }
    },
    inputs: {
      max: "max",
      min: "min",
      resize: "resize"
    },
    standalone: false
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotFrameComponentBase, [{
    type: Directive,
    args: [{
      host: {
        '[class._resize]': 'resize'
      },
      standalone: false
    }]
  }], () => [], {
    max: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    resize: [{
      type: Input
    }]
  });
})();
class DotFrameContainerComponent extends DotFrameComponentBase {
  constructor() {
    super();
    const injector = inject(Injector);
    const renderer = injector.get(DotRendererService);
    const host = injector.get(ElementRef).nativeElement;
    renderer.setProperty(host, '.cutChild', true);
  }
  static ɵfac = function DotFrameContainerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotFrameContainerComponent)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotFrameContainerComponent,
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotFrameContainerComponent, [{
    type: Directive
  }], () => [], null);
})();
class DotsComponent extends DotFrameComponentBase {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotsComponent_BaseFactory;
    return function DotsComponent_Factory(__ngFactoryType__) {
      return (ɵDotsComponent_BaseFactory || (ɵDotsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotsComponent)))(__ngFactoryType__ || DotsComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotsComponent,
    selectors: [["dots"]],
    hostAttrs: ["id", "dots", "role", "article"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotsComponent, [{
    type: Component,
    args: [{
      selector: 'dots',
      template: `
		<ng-content></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dots',
        role: 'article'
      },
      standalone: false
    }]
  }], null, null);
})();
class DotHeadComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotHeadComponent_BaseFactory;
    return function DotHeadComponent_Factory(__ngFactoryType__) {
      return (ɵDotHeadComponent_BaseFactory || (ɵDotHeadComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotHeadComponent)))(__ngFactoryType__ || DotHeadComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotHeadComponent,
    selectors: [["dot-head"]],
    hostAttrs: ["id", "dot-head"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-head-area", "dotFrameArea", ""]],
    template: function DotHeadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotHeadComponent, [{
    type: Component,
    args: [{
      selector: 'dot-head',
      template: `
		<div id="dot-head-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-head'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotMainComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotMainComponent_BaseFactory;
    return function DotMainComponent_Factory(__ngFactoryType__) {
      return (ɵDotMainComponent_BaseFactory || (ɵDotMainComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotMainComponent)))(__ngFactoryType__ || DotMainComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotMainComponent,
    selectors: [["dot-main"]],
    hostAttrs: ["id", "dot-main", "role", "main"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-main-area", "dotFrameArea", ""]],
    template: function DotMainComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotMainComponent, [{
    type: Component,
    args: [{
      selector: 'dot-main',
      template: `
		<div id="dot-main-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-main',
        role: 'main'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotPageComponent {
  static ɵfac = function DotPageComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPageComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPageComponent,
    selectors: [["dot-page"]],
    hostAttrs: ["id", "dot-page", "role", "article"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotPageComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageComponent, [{
    type: Component,
    args: [{
      selector: 'dot-page',
      template: `
		<ng-content></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-page',
        role: 'article'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotPageHeadComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotPageHeadComponent_BaseFactory;
    return function DotPageHeadComponent_Factory(__ngFactoryType__) {
      return (ɵDotPageHeadComponent_BaseFactory || (ɵDotPageHeadComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotPageHeadComponent)))(__ngFactoryType__ || DotPageHeadComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPageHeadComponent,
    selectors: [["dot-page-head"]],
    hostAttrs: ["id", "dot-page-head"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-page-head-area", "dotFrameArea", ""]],
    template: function DotPageHeadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageHeadComponent, [{
    type: Component,
    args: [{
      selector: 'dot-page-head',
      template: `
		<div id="dot-page-head-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-page-head'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotPageMainComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotPageMainComponent_BaseFactory;
    return function DotPageMainComponent_Factory(__ngFactoryType__) {
      return (ɵDotPageMainComponent_BaseFactory || (ɵDotPageMainComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotPageMainComponent)))(__ngFactoryType__ || DotPageMainComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPageMainComponent,
    selectors: [["dot-page-main"]],
    hostAttrs: ["id", "dot-page-main", "role", "main"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-page-main-area", "dotFrameArea", ""]],
    template: function DotPageMainComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageMainComponent, [{
    type: Component,
    args: [{
      selector: 'dot-page-main',
      template: `
		<div id="dot-page-main-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-page-main',
        role: 'main'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotPageFootComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotPageFootComponent_BaseFactory;
    return function DotPageFootComponent_Factory(__ngFactoryType__) {
      return (ɵDotPageFootComponent_BaseFactory || (ɵDotPageFootComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotPageFootComponent)))(__ngFactoryType__ || DotPageFootComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPageFootComponent,
    selectors: [["dot-page-foot"]],
    hostAttrs: ["id", "dot-page-foot", "role", "contentinfo"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-page-foot-area", "dotFrameArea", ""]],
    template: function DotPageFootComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPageFootComponent, [{
    type: Component,
    args: [{
      selector: 'dot-page-foot',
      template: `
		<div id="dot-page-foot-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-page-foot',
        role: 'contentinfo'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotFootComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotFootComponent_BaseFactory;
    return function DotFootComponent_Factory(__ngFactoryType__) {
      return (ɵDotFootComponent_BaseFactory || (ɵDotFootComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotFootComponent)))(__ngFactoryType__ || DotFootComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotFootComponent,
    selectors: [["dot-foot"]],
    hostAttrs: ["id", "dot-foot", "role", "contentinfo"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-foot-area", "dotFrameArea", ""]],
    template: function DotFootComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotFootComponent, [{
    type: Component,
    args: [{
      selector: 'dot-foot',
      template: `
		<div id="dot-foot-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-foot',
        role: 'contentinfo'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotAsideComponent extends DotFrameContainerComponent {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵDotAsideComponent_BaseFactory;
    return function DotAsideComponent_Factory(__ngFactoryType__) {
      return (ɵDotAsideComponent_BaseFactory || (ɵDotAsideComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DotAsideComponent)))(__ngFactoryType__ || DotAsideComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotAsideComponent,
    selectors: [["dot-aside"]],
    hostAttrs: ["id", "dot-aside", "role", "complementary"],
    standalone: false,
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["id", "dot-aside-area", "dotFrameArea", ""]],
    template: function DotAsideComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotFrameAreaDirective],
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotAsideComponent, [{
    type: Component,
    args: [{
      selector: 'dot-aside',
      template: `
		<div id="dot-aside-area" dotFrameArea>
			<ng-content></ng-content>
		</div>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-aside',
        role: 'complementary'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotAreaComponent {
  static ɵfac = function DotAreaComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotAreaComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotAreaComponent,
    selectors: [["dot-area"]],
    hostAttrs: [1, "dot-area"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotAreaComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotAreaComponent, [{
    type: Component,
    args: [{
      selector: 'dot-area',
      template: `
		<ng-content></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-area'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
class DotPadComponent {
  static ɵfac = function DotPadComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotPadComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotPadComponent,
    selectors: [["dot-pad"]],
    hostAttrs: [1, "dot-pad"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotPadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [_c1, _c2, _c3],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotPadComponent, [{
    type: Component,
    args: [{
      selector: 'dot-pad',
      template: `
		<ng-content></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-pad'
      },
      standalone: false,
      styles: ["body,html{min-height:100%}body{line-height:1;word-break:break-all}a,abbr,acronym,address,article,aside,audio,b,big,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,main,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0}h1,h2,h3,h4,h5,h6{margin:0;font-size:100%}a{text-decoration:none}address,em,time var{font:inherit}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}ol,ul{list-style-type:none}table{border-collapse:collapse;border-spacing:0}th{text-align:left}a,button,input,select,textarea{font-size:inherit;font-family:inherit;color:inherit}button,input[type=button],input[type=submit],label{cursor:pointer}hr{display:none}code{font-family:Courier New,sans-serif}button,table thead thead td,table thead thead th{word-break:normal}\n", "#dots{min-height:100%;display:flex;flex-direction:column;align-content:center}#dot-head{z-index:2}#dot-main{flex-grow:1;display:flex;flex-direction:column}#dot-main-area{min-height:100%;flex-grow:1}#dot-page-head{z-index:1}.dot-pad{padding:var(--frame-pads)}:root{--frame-width:100%;--frame-pads:0 18px;--frame-desktop-pads:0;--frame-ani-duration:.24s;--frame-min-width:320px;--frame-max-width:1600px}body{min-width:var(--frame-min-width)}#dot-foot,#dot-head,#dot-main,#dot-page-foot,#dot-page-head,#dot-page-main,:has(>.dot-area){container-name:dot-frame;container-type:inline-size}#dot-foot-area,#dot-head-area,#dot-main-area,#dot-page-foot-area,#dot-page-head-area,#dot-page-main-area,.dot-area{width:max(var(--frame-min-width),min(var(--frame-width),var(--frame-max-width)));margin:0 auto}#dot-foot-area._resize,#dot-head-area._resize,#dot-main-area._resize,#dot-page-foot-area._resize,#dot-page-head-area._resize,#dot-page-main-area._resize,.dot-area._resize{width:100%}\n", "dots,dot-head,dot-main,dot-main-head,dot-main-title,dot-foot,dot-navs,dot-area,dot-pad{display:block}dots{min-height:100vh!important}\n"]
    }]
  }], null, null);
})();
/**
 * @deprecated Use dot-page-head instead.
 */
class DotTitleComponent {
  constructor(main) {
    console.warn('[.frame] `dot-title` are deprecated');
  }
  static ɵfac = function DotTitleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotTitleComponent)(i0.ɵɵdirectiveInject(DotMainComponent));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotTitleComponent,
    selectors: [["dot-title"]],
    hostAttrs: ["id", "dot-main-title"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 3,
    vars: 0,
    template: function DotTitleComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "dot-pad")(1, "h1");
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd()();
      }
    },
    dependencies: [DotPadComponent],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotTitleComponent, [{
    type: Component,
    args: [{
      selector: 'dot-title',
      template: `
		<dot-pad>
			<h1>
				<ng-content></ng-content>
			</h1>
		</dot-pad>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-main-title'
      },
      standalone: false
    }]
  }], () => [{
    type: DotMainComponent
  }], null);
})();
/**
 * @deprecated Use dot-page-head instead.
 */
class DotMainHeadComponent {
  constructor(main) {
    console.warn('[.frame] `dot-main-head` is deprecated, Use `dot-page-head` instead.');
  }
  static ɵfac = function DotMainHeadComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotMainHeadComponent)(i0.ɵɵdirectiveInject(DotMainComponent));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotMainHeadComponent,
    selectors: [["dot-main-head"]],
    hostAttrs: ["id", "dot-main-head", 1, "_cut_for_child"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [[1, "_dot-target"]],
    template: function DotMainHeadComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "dot-area", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [DotAreaComponent],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotMainHeadComponent, [{
    type: Component,
    args: [{
      selector: 'dot-main-head',
      template: `
		<dot-area class="_dot-target">
			<ng-content></ng-content>
		</dot-area>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        id: 'dot-main-head',
        class: '_cut_for_child'
      },
      standalone: false
    }]
  }], () => [{
    type: DotMainComponent
  }], null);
})();
/**
 * @deprecated
 */
class DotSectionComponent {
  constructor() {
    console.warn('[.frame] `dot-section` is deprecated, Use `section` instead');
  }
  static ɵfac = function DotSectionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotSectionComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotSectionComponent,
    selectors: [["dot-section"]],
    hostAttrs: [1, "dot-section"],
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DotSectionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotSectionComponent, [{
    type: Component,
    args: [{
      selector: 'dot-section',
      template: `
		<ng-content></ng-content>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-section'
      },
      standalone: false
    }]
  }], () => [], null);
})();
class DotFrameModule {
  static ɵfac = function DotFrameModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotFrameModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotFrameModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotFrameModule, [{
    type: NgModule,
    args: [{
      declarations: [DotFrameAreaDirective, DotsComponent, DotHeadComponent, DotMainComponent, DotPageComponent, DotPageHeadComponent, DotPageMainComponent, DotPageFootComponent, DotFootComponent, DotAreaComponent, DotPadComponent, DotAsideComponent,
      // deprecates
      DotMainHeadComponent, DotTitleComponent, DotSectionComponent],
      exports: [DotsComponent, DotHeadComponent, DotMainComponent, DotPageComponent, DotPageHeadComponent, DotPageMainComponent, DotPageFootComponent, DotFootComponent, DotAreaComponent, DotPadComponent, DotAsideComponent,
      // deprecates
      DotMainHeadComponent, DotTitleComponent, DotSectionComponent],
      imports: [CommonModule]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotAreaComponent, DotAsideComponent, DotFootComponent, DotFrameAreaDirective, DotFrameComponentBase, DotFrameContainerComponent, DotFrameModule, DotHeadComponent, DotMainComponent, DotMainHeadComponent, DotPadComponent, DotPageComponent, DotPageFootComponent, DotPageHeadComponent, DotPageMainComponent, DotSectionComponent, DotTitleComponent, DotsComponent, STYLE_URLS };
